import { useQuery } from '@tanstack/react-query';
import { adminApi } from '@/features/admin/api/adminApi';
import { User, UserFilters } from '@/types/user';

/**
 * Custom hook for admin user management with TanStack Query.
 */
export const useAdminUsers = (filters?: UserFilters) => {
  const { data: users = [], isLoading, isError, error, refetch } = useQuery({
    queryKey: ['adminUsers', filters],
    queryFn: () => adminApi.getAllUsers(filters),
    retry: 1,
  });

  return {
    users,
    isLoading,
    isError,
    error,
    refetch,
  };
};
